import React, { useEffect, useState } from 'react';
import {
  Container, Typography, TextField, Button, Alert, Autocomplete, MenuItem
} from '@mui/material';
import contrattoApi from '../../api/contrattoApi';
import userApi from '../../api/userApi';
import tipoContrattoApi from '../../api/tipocontrattoApi';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function ContrattoCreatePage() {
  const [form, setForm] = useState({
    tipocontrattoId: '',
    dataInizio: '',
    dataFine: '',
    canoneAnnuo: '',
    utenteId: null
  });
  const [users, setUsers] = useState([]);
  const [tipiContratto, setTipiContratto] = useState([]);
  const [err, setErr] = useState(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/contratti'; // default redirect

  useEffect(() => {
    // Carica tipi contratto attivi tramite API dedicata
    tipoContrattoApi.getAll()
      .then(r => setTipiContratto(r.data.filter(t => t.attivo)))
      .catch(e => setErr(e.response?.data || e.message));

    const utenteId = searchParams.get('utenteId');
    if (utenteId) {
      setForm(f => ({ ...f, utenteId: Number(utenteId) }));
      userApi.get(utenteId)
        .then(r => setUsers([r.data]))
        .catch(e => setErr(e.response?.data || e.message));
    } else {
      userApi.findUsersWithoutContratto()
        .then(r => setUsers(r.data))
        .catch(e => setErr(e.response?.data || e.message));
    }
  }, [searchParams]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const response=await contrattoApi.create(form);
      console.log("contratto creato",response);
      navigate(`/contratti/${response.data.id}/edit`, { replace: true });
    } catch (e) {
      setErr(e.response?.data || e.message);
    }
  };

  return (
    <Container>
      <Typography variant="h5">Crea Contratto</Typography>
      {err && <Alert severity="error">{String(err)}</Alert>}
      <form onSubmit={submit}>
        <TextField
          select
          fullWidth
          label="Tipo Contratto"
          value={form.tipocontrattoId}
          onChange={e => {
            const tipoId = e.target.value;
            const tipo = tipiContratto.find(t => t.id === tipoId);

            setForm({
              ...form,
              tipocontrattoId: tipoId,
              canoneAnnuo: tipo ? tipo.canoneAnnuo : ''
            });
          }}
          sx={{ my: 1 }}
          required
        >
          {tipiContratto.map(t => (
            <MenuItem key={t.id} value={t.id}>
              {t.tipo} - {t.canoneAnnuo} €
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          type="date"
          label="Data Inizio"
          InputLabelProps={{ shrink: true }}
          value={form.dataInizio}
          onChange={e => setForm({...form, dataInizio: e.target.value})}
          sx={{ my: 1 }}
          required
        />
        <TextField
          fullWidth
          type="date"
          label="Data Fine"
          InputLabelProps={{ shrink: true }}
          value={form.dataFine}
          onChange={e => setForm({...form, dataFine: e.target.value})}
          sx={{ my: 1 }}
          required
        />
        <TextField
          fullWidth
          type="number"
          label="Canone Annuo"
          value={form.canoneAnnuo}
          onChange={e => setForm({...form, canoneAnnuo: e.target.value})}
          sx={{ my: 1 }}
          required
        />

        <Autocomplete
          options={users}
          getOptionLabel={(option) => option.username + ' - ' + option.email}
          value={users.find(u => u.id === form.utenteId) || null}
          onChange={(event, value) => setForm({...form, utenteId: value?.id || null})}
          renderInput={(params) => <TextField {...params} label="Seleziona Utente" />}
          sx={{ my: 1 }}
          disabled={!!searchParams.get('utenteId')}
          required
        />

        <Button variant="contained" type="submit">Crea</Button>
      </form>
    </Container>
  );
}